import { getTrialFeatures } from '@/api/brandBilling'
import { buildMenuTrialMarkMap } from '@/utils/trialSidebarMarks'

function unwrapFeatures (res) {
  const body = (res && res.data) != null ? res.data : res
  if (Array.isArray(body)) return body
  return (body && body.features) || []
}

function unwrapThreshold (res) {
  const body = (res && res.data) != null ? res.data : res
  return (body && body.expiringDaysThreshold) || 3
}

const state = {
  features: [],
  expiringDaysThreshold: 3,
  loading: false,
  lastRefreshAt: ''
}

const mutations = {
  SET_TRIAL_FEATURES (state, payload) {
    state.features = (payload && payload.features) || []
    state.expiringDaysThreshold = (payload && payload.expiringDaysThreshold) || 3
    state.lastRefreshAt = (payload && payload.lastRefreshAt) || ''
  },
  SET_TRIAL_FEATURES_LOADING (state, v) {
    state.loading = !!v
  }
}

const getters = {
  features (state) {
    return state.features || []
  },
  visibleFeatures (state, getters) {
    return (getters.features || []).filter(function (f) {
      return f && f.phase && f.phase !== 'PAID' && f.phase !== 'PAID_ACTIVE'
    })
  },
  visibleCount (state, getters) {
    return (getters.visibleFeatures || []).length
  },
  featureByKey: (state) => (key) => {
    const k = String(key || '').trim()
    if (!k) return null
    return (state.features || []).find(function (f) {
      return f && (f.featureKey === k || f.skuCode === k || f.promoSku === k)
    }) || null
  },
  loading (state) {
    return state.loading
  },
  menuTrialMarkMap (state, getters, rootState) {
    const menuList = (rootState.common && rootState.common.menuList) || []
    return buildMenuTrialMarkMap(menuList, getters.features)
  },
  menuTrialMark: (state, getters) => (menuId) => {
    if (menuId == null || menuId === '') return null
    return getters.menuTrialMarkMap[String(menuId)] || null
  }
}

const actions = {
  async refresh ({ commit }) {
    commit('SET_TRIAL_FEATURES_LOADING', true)
    try {
      const res = await getTrialFeatures().catch(function () { return { data: { features: [] } } })
      commit('SET_TRIAL_FEATURES', {
        features: unwrapFeatures(res),
        expiringDaysThreshold: unwrapThreshold(res),
        lastRefreshAt: new Date().toISOString()
      })
      return unwrapFeatures(res)
    } finally {
      commit('SET_TRIAL_FEATURES_LOADING', false)
    }
  }
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
}



// WEBPACK FOOTER //
// ./src/store/modules/trialFeatures.js